(() => {
  angular.module('app').component('kpiEngineEntry', {
    template: `<new-front-container path="'kpi-engine'" query="ctrl.query"
        params="ctrl.params" on-state-changed="ctrl.onStateChanged(params)"></new-front-container>`,
    controller: Controller,
    controllerAs: 'ctrl',
    bindings: { $transition$: '<' },
  });
  Controller.$inject = ['NativeAppIntegration', '$state'];
  function Controller(integration, $state) {
    const vm = this;
    // The React app names the legacy tabs after what they hold.
    const legacyTabs = { indicators: 'expressions', parameters: 'constants', sources: 'variables' };
    integration.syncState('kpi-engine', vm, $state, params => ({ ...params, tab: legacyTabs[params.tab] || params.tab }));
    vm.$onInit = () => {
      vm.params = integration.params('kpi-engine', vm.$transition$.params());
      vm.query = vm.params;
    };
  }
})();
